import { FC } from 'react';
import styled from 'styled-components';

import { zIndex } from 'ui/theme';

export const StyledHeader = styled.header`
  flex: 0 0 auto;
  z-index: ${zIndex.nav};
`;

export const Header: FC<React.PropsWithChildren<unknown>> = ({ children, ...props }) => (
  <StyledHeader {...props}>{children}</StyledHeader>
);
